import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const TYPES = [
  { v: "access", t: "Droit d'accès à mes données" },
  { v: "rectification", t: "Droit de rectification" },
  { v: "deletion", t: "Droit à l'effacement (suppression)" },
  { v: "opposition", t: "Droit d'opposition" },
];

export default function RGPDRequest() {
  const [form, setForm] = useState({ email: "", request_type: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.request_type) return toast.error("Sélectionnez un type de demande");
    setBusy(true);
    try {
      await api.post("/rgpd/requests", form);
      toast.success("Demande RGPD enregistrée. Nous vous répondrons sous 30 jours.");
      setForm({ email: "", request_type: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <section className="hero-bg py-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="text-gold uppercase tracking-widest text-sm font-semibold">Vos droits</div>
          <h1 className="font-heading text-4xl text-primary-blue mt-3">Exercer mes droits RGPD</h1>
          <p className="mt-3 text-slate-700">Vous disposez de plusieurs droits sur vos données personnelles. Remplissez ce formulaire pour les exercer.</p>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-14">
        <form onSubmit={submit} className="bg-white p-8 rounded-2xl border border-slate-100 card-lux space-y-5" data-testid="rgpd-form">
          <div>
            <Label>E-mail utilisé lors de la demande</Label>
            <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required className="mt-1 h-11" data-testid="rgpd-email" />
          </div>
          <div>
            <Label>Type de demande</Label>
            <Select value={form.request_type} onValueChange={(v) => set("request_type", v)}>
              <SelectTrigger className="mt-1 h-11" data-testid="rgpd-type"><SelectValue placeholder="Choisissez…" /></SelectTrigger>
              <SelectContent>
                {TYPES.map((t) => <SelectItem key={t.v} value={t.v}>{t.t}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Message</Label>
            <Textarea rows={5} value={form.message} onChange={(e) => set("message", e.target.value)} required className="mt-1" data-testid="rgpd-message" />
          </div>
          <Button type="submit" disabled={busy} className="bg-primary-blue text-white" data-testid="rgpd-submit">
            {busy ? "Envoi…" : "Envoyer ma demande"}
          </Button>
        </form>
      </section>
    </div>
  );
}
